import React from "react";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background p-4">
      <div className="text-center max-w-md">

        {/* 404 */}
        <div className="flex justify-center mb-6">
          <h1 className="text-9xl font-bold text-primary opacity-20">404</h1>
        </div>

        <h2 className="text-2xl font-medium text-onBackground mb-2">
          Page Not Found
        </h2>

        <p className="text-onBackground/70 mb-8">
          The page you're looking for doesn't exist. Let’s get you back!
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">

          {/* Back Button (NO ICONS → STABLE) */}
          <button
            onClick={() => window.history.back()}
            className="
              px-6 py-3 rounded-full 
              bg-primary text-white 
              hover:bg-primary/90 
              transition font-semibold
            "
          >
            ← Go Back
          </button>

          {/* Home Button */}
          <button
            onClick={() => navigate("/")}
            className="
              px-6 py-3 rounded-full 
              border border-onBackground/40 
              text-onBackground 
              hover:bg-white/10 
              transition font-semibold
            "
          >
            ⌂ Back to Home
          </button>

        </div>
      </div>
    </div>
  );
};

export default NotFound;
